import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Bank } from '../models/bank';

@Injectable({
  providedIn: 'root'
})
export class BankService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any
  ) {}

  public getBank(routingNumber: string): Observable<Bank> {
    return this.http.get<Bank>(`${this.env.apiUrlRoot}/Banks/${routingNumber}`);
  }

  public getBanksLike(routingNumberLike: string): Observable<Bank[]> {
    return this.http.get<Bank[]>(`${this.env.apiUrlRoot}/banks/getBanksLike/${routingNumberLike}`);
  }
}
